/** Height of the sticky app header the aside sits below. */
const HEADER_HEIGHT = 75;

/**
 * Gap between the header and the top of the aside on desktop.
 *
 * The aside is sticky at `HEADER_HEIGHT + ASIDE_GAP` and also sits in flow
 * with a top margin of `ASIDE_GAP`, so its natural position is already where
 * sticky wants it. If those two drift apart, sticky has to shift the aside
 * by the difference, and it can only do so when the page is tall enough to
 * give it room, so the nav would jump between short and long pages.
 */
const ASIDE_GAP = 20;

const ASIDE_TOP = HEADER_HEIGHT + ASIDE_GAP;

const styles = theme => ({
  bgcolor: 'grey.100',
  left: 0,
  overflow: 'auto',

  '&::-webkit-scrollbar': {
    width: '0px',
    // width: '8px',
    height: '8px',
    backgroundColor: 'transparent',
  },
  '&::-webkit-scrollbar-track': {
    backgroundColor: 'transparent',
  },
  '&::-webkit-scrollbar-thumb': {
    // backgroundColor: 'rgba(0, 0, 0, 0.2)',
    backgroundColor: 'transparent',
    borderRadius: '4px',
  },
  // mobile styles
  [theme.breakpoints.down('md')]: {
    position: 'fixed',
    top: `${HEADER_HEIGHT}px`,
    height: `calc(100vh - ${HEADER_HEIGHT}px)`,
    zIndex: 99,
  },
  // desktop
  [theme.breakpoints.up('md')]: {
    position: 'sticky',
    top: `${ASIDE_TOP}px`,
    height: `calc(100vh - ${ASIDE_TOP}px)`,
    mt: `${ASIDE_GAP}px`,
    zIndex: '1 !important',
  },
});

export default styles;
